import React, { useContext, useEffect, useState } from 'react'
import { APIGet, APIPost } from '../utils/ApiClient'
import { AboutJob } from './AboutJob'
import { SponsoredJobsCarousel } from './SponsoredJobsCarousel'
import { JOB_SEARCH_APPLY, PROMOTED_JOBS_END_URL } from '../constants/all'
import useTranslation from '../hooks/useTranslation'
import { JobsFilteringSkeletonLoading } from './JobsFilteringSkeletonLoading'
import { NoInternetComponent } from './NoInternetComponent'
import classNames from 'classnames'
import ReactPaginate from 'react-paginate'
import { useRouter } from 'next/router'
import { SharedContext } from '../context/SharedContext'
import { SeekerContext } from '../context/SeekerContext'

export const FilteredJobs = ({ setShowSponsoredJobs }) => {
  const translation = useTranslation()
  const [filteredJobsObject, setFilteredJobsObject] = useState({})
  const [sponsoredJobsObject, setSponsoredJobsObject] = useState({})
  const {
    location,
    isOnline,
    language,
  } = useContext(SharedContext);

  const {
    body,
    setBody,
    pageTitles,
    setPageTitles,
    filterTitleIds,
    filterNameWFH,
    currentPage,
    setCurrentPage,
    setClickedHRCTA
  } = useContext(SeekerContext);
  const [loading, setLoading] = useState(true)
  const query = useRouter()?.query

  useEffect(() => {
    fetchNextJobDetails()
    setClickedHRCTA(false)
  }, [currentPage])

  function PaginateJobs({ itemsPerPage }) {
    const pageCount = Math.ceil(filteredJobsObject?.count / itemsPerPage)

    const handlePageChange = (selectedPage) => {
      setCurrentPage(selectedPage.selected)
      try {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      } catch (error) {
        console.error('Error scrolling to top:', error)
      }
    }

    const currentItems = filteredJobsObject?.results

    return (
      <div className="mx-[12px] sm:mx-[0px]" id="recommendjobs_list">
        {currentItems.map((item, index) => (
          <AboutJob jobDetails={item} key={index} />
        ))}
        <ReactPaginate
          previousLabel={'<'}
          nextLabel={'>'}
          breakLabel="..."
          pageCount={pageCount}
          marginPagesDisplayed={1}
          pageRangeDisplayed={2}
          onPageChange={handlePageChange}
          containerClassName={'pagination'}
          activeClassName={'active'}
          forcePage={currentPage}
        />
      </div>
    )
  }

  const fetchNextJobDetails = async () => {
    let data
    const params = {
      page: currentPage + 1
    }
    const headers = { 'App-Type': 'web' }
    let bodyAPI = {
      location_type: 'city',
      location_id: location?.id || location?.city_id,
      city_location_id: location?.district_id,
      filters: { ...body?.apiBody }
    }
    data = await APIPost(JOB_SEARCH_APPLY, headers, params, bodyAPI, false, false)
    if (data?.results) {
      let results
      await setFilteredJobsObject((prv) => {
        let jobs = data?.results?.filter((item) => item?.job_role && item?.title)

        prv.results = jobs
        return { ...prv }
      })
    }
  }

  const postMethodHandler = async () => {
    if (Object?.keys(sponsoredJobsObject || [])?.length <= 0) {
      const promotedJobsParams = {
        page: 1,
        location_id: location?.district_id || 9,
        category_id: 2
      }
      setLoading(true)
      const result = await APIGet(
        PROMOTED_JOBS_END_URL,
        { 'Accept-Language': language, source: 'jobs_web', 'App-Type': 'web' },
        promotedJobsParams
      )

      setSponsoredJobsObject(result)
    }

    let params = { page: currentPage + 1 }
    let headers = { 'App-Type': 'web' }
    let bodyAPI = {
      location_type: 'city',
      location_id: location?.id || location?.city_id,
      city_location_id: location?.district_id,
      filters: { ...body?.apiBody }
    }
    let data
    data = await APIPost(JOB_SEARCH_APPLY, headers, params, bodyAPI, false, false)
    try {
      if (window) window?.scrollTo({ top: 0 })
    } catch {}
    let jobs = data?.results?.filter((item) => item?.job_role && item?.title)
    setFilteredJobsObject({ ...data, results: jobs })
    setLoading(false)
  }

  useEffect(() => {
    if (Object?.keys(filterTitleIds)?.length > 0) {
      if (isOnline) postMethodHandler()
      const isOneCategory = body?.apiBody?.[filterTitleIds['Job Category']]?.length == 1
      setPageTitles((prev) => {
        prev?.['jobsFiltering']?.pop()
        const headerData = body?.selectedOptions?.[filterTitleIds['Job Category']]?.[0]
        return {
          ...prev,
          jobsFiltering: [
            ...prev?.['jobsFiltering'],
            isOneCategory ? headerData?.title || headerData?.value : translation?.jobs
          ]
        }
      })
    }
  }, [body, isOnline, filterTitleIds])

  useEffect(() => {
    if (query?.filterName == 'Work From Home' || filterNameWFH == 'Work From Home') {
      setBody({
        apiBody: { 6: [process.env.NEXT_PUBLIC_OPTION_WORK_FROM_HOME] },
        selectedOptions: {
          6: [
            {
              id: process.env.NEXT_PUBLIC_OPTION_WORK_FROM_HOME,
              filter_value: [process.env.NEXT_PUBLIC_OPTION_WORK_FROM_HOME]
            }
          ]
        }
      })
    }
    if (query?.filterName == 'High salary jobs' || filterNameWFH == 'High salary jobs') {
      setBody({
        apiBody: { 1: [20001, 1000000] },
        selectedOptions: {
          1: [
            {
              id: process.env.NEXT_PUBLIC_OPTION_HIGH_SALARY_3,
              filter_value: [50000, 1000000]
            },
            {
              id: process.env.NEXT_PUBLIC_OPTION_HIGH_SALARY_2,
              filter_value: [30001, 50000]
            },
            {
              id: process.env.NEXT_PUBLIC_OPTION_HIGH_SALARY_1,
              filter_value: [20001, 30000]
            }
          ]
        }
      })
    }
  }, [query?.filterName, filterNameWFH])

  return loading ? (
    <div id="fj_skeleton_loading">
      <JobsFilteringSkeletonLoading visible={loading} />
    </div>
  ) : (
    <>
      {!isOnline ? (
        <div id="fj_no_internet_component">
          <NoInternetComponent />
        </div>
      ) : (
        filteredJobsObject?.results?.length > 0 && (
          <div id="fj_sponsored_jobs_carosel" className="widthOfjobs overflow-x-hidden">
            {sponsoredJobsObject?.results?.length > 0 && (
              <SponsoredJobsCarousel
                data={sponsoredJobsObject?.results}
                setShowSponsoredJobs={setShowSponsoredJobs}
              />
            )}
            <div
              className={classNames('w-full bg-[#F8F8F8] sm:pr-[24px] md:pr-[0px]')}
              id="recommend_jobs_container"
            >
              <h1
                className="select-none pl-[12px] pt-[16px] font-noto-sans text-[18px] font-bold leading-[28.8px]  sm:pl-[0px] sm:pt-[31px] sm:text-[24px] sm:leading-[38.4px]"
                id="recommend_jobs_text"
              >
                {pageTitles.jobsFiltering[pageTitles.jobsFiltering.length - 1] === 'Jobs'
                  ? translation.jobListing
                  : translation.recommendedJobs}
              </h1>
              <PaginateJobs {...{ itemsPerPage: 10 }} />
            </div>
          </div>
        )
      )}
    </>
  )
}
